export const WelcomeStepProfile = {
  bindings: {
    member: '<',
    isLoading: '<',
    onSubmit: '&',
    onUpdate: '&',
    onUploadComplete: '&',
  },

  template: `
    <div class="welcome-step-profile py-4">
      <h1 class="h2 text-center text-white mb-4">
        Create your profile
      </h1>
      <section class="theme-light p-3 mb-5">
        <form class="voome-form"
          name="form"
          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"
          novalidate>
          <div class="mb-3">
            <profile-container is-editing="true">
              <profile-fields
                form="form"
                member="$ctrl.member"
                is-editing="true"
                on-update="$ctrl.onUpdate({ key: key, value: value })"
                on-upload-complete="$ctrl.onUploadComplete()">
              </profile-fields>
            </profile-container>
          </div>
          <div class="mb-3">
            <profile-container is-editing="true">
              <profile-fields-more
                form="form"
                member="$ctrl.member"
                is-editing="true"
                on-update="$ctrl.onUpdate({ key: key, value: value })">
              </profile-fields-more>
            </profile-container>
          </div>
          <div class="text-center">
            <button-primary
              ng-type="submit"
              ng-disabled="$ctrl.isLoading || form.$invalid">
              <spinner is-loading="$ctrl.isLoading">
                Next
              </spinner>
            </button-primary>
          </div>
        </form>
      </section>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepProfile.js